

document.addEventListener('teeinblue-event-component-injected', function() {
  moveElementBefore('#main-product [data-banners]', '.tee-description');
  moveElementBefore('.l4al.trust-badges', '#main-product [data-banners]');
  // const mainElement = document.querySelector('.tee-description');

  // if (!mainElement) {
  //   return;
  // }

  // const observer = new MutationObserver((mutations, obs) => {
  //   const moveElement = document.querySelector('#main-product [data-banners]');
  //   if (moveElement) {
  //     mainElement.before(moveElement);
  //     obs.disconnect(); 
  //   }
  // });

  // observer.observe(document.body, {
  //   childList: true,
  //   subtree: true
  // });
});

const moveElementBefore = (before, main) => {
  const mainElement = document.querySelector(main);

  if (!mainElement) {
    return;
  }

  const observer = new MutationObserver((mutations, obs) => {
    const moveElement = document.querySelector(before);
    if (moveElement) {
      mainElement.before(moveElement);
      obs.disconnect(); 
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}


